import { set_ai_opts_for_preview } from '../../formElements/RSAI/utils';
import { onLink, onSubmit, save } from '../../handlers';
import { updateSectionData } from '../../handlers/utils';
import { getUsefulVars } from '../../handlers/helpers';
import { progressiveFormStepper } from '../ProgressiveFormStepper/utils';
import { Box, Heading } from '@chakra-ui/react';

export const hasSection = (props, sectionName) => {
  const stateProps = props.stateProps;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const resumes = stateProps.dataToSave.saved.resumes;
  const resume = resumes[resumeIndex];
  if ((typeof resume[sectionName] !== 'undefined' && resume[sectionName].length > 0) || (sectionName === 'emptySections' || sectionName === 'start')) {
    return true;
  }
  return false;
};
export const openPreview = (props, index = -1) => {
  if (index !== -1) {
    props.stateProps.sectionData.resumeIndex = index;
  }
  const resumeIndex = props.stateProps.sectionData.resumeIndex;
  if (props.stateProps.dataToSave.saved.resumes[resumeIndex].download === undefined) {
    set_ai_opts_for_preview(props, resumeIndex);
  } else {
    onLink(false, props.formikProps, props.stateProps, 'preview', index, 'section', resumeIndex);
  }
};
export const previewEditButton = (props, target) => {
  if (target === 'download') {
    const uv = getUsefulVars(props);
    uv.resume.regenCS = false;
    onLink(false, props.formikProps, props.stateProps, target, 0, 'section');

    //props.stateProps.setaiopts([]);
  } else {
    onLink(false, props.formikProps, props.stateProps, target, 0, 'section');
  }
};
export const getAccordionVars = (previews, sectionName, myData) => {
  let sectionObj = previews[sectionName];
  sectionObj = sectionName === 'download' && typeof sectionObj === 'undefined' ? {} : sectionObj;
  let label = '';
  let buttonLabel = 'Edit';
  if (typeof sectionObj !== 'undefined') {
    label = sectionObj.label === 'Download' ? 'Career Summary' : sectionObj.label;
  }
  if (sectionName === 'download') {
    if (myData.download !== undefined && myData.download[0] !== undefined && myData.download[0]['D1'] !== undefined) {
      buttonLabel = 'Regenerate';
    } else {
      buttonLabel = 'Generate';
    }
  }
  return [sectionObj, label, buttonLabel];
};
export const getQuestions = (previews, sectionName) => {
  const sectionObj = previews[sectionName];
  if (typeof sectionObj !== 'undefined' && typeof sectionObj.questions !== 'undefined') {
    return sectionObj.questions[0];
  } else {
    return [];
  }
};
export const getEmptySections = (props) => {
  const allSections = [
    ['academic-projects', 'Academic Projects'],
    ['awards-recognitions', 'Awards & Recognitions'],
    ['contact', 'Contact'],
    ['education', 'Education'],
    ['extracurricular-activities', 'Extracurricular Activities'],
    ['languages', 'Languages'],
    ['licenses-certifications', 'Licenses & Certifications'],
    ['professional-experience', 'Professional Experience'],
    ['technical-skills', 'Expertise & Skills'],
    ['computer-skills', 'Computer Skills'],
    ['volunteer-experience', 'Volunteer Experience'],
  ];
  const emptySections = [];
  allSections.forEach(([sectionName, sectionTitle]) => {
    if (!hasSection(props, sectionName)) {
      emptySections.push([sectionName, sectionTitle]);
    }
  });
  return emptySections;
};

export const freeFormEdit = (e,props,paragraphIndex) => {
  const uv = getUsefulVars(props);
  const newLabel = e.currentTarget.value;
  const coverLetter = uv.resume['parse-letter'][0].PL6;
  coverLetter[paragraphIndex] = newLabel;
  save(uv.stateProps,uv.resumeIndex);

}
export const returnToPreviewFromRegenerate = (props) => {
  updateSectionData({ sectionName: 'preview' }, props.stateProps);
};
export const composeBullet = (bullet) => {
  const labelParts = bullet.label.split('~');
  if (labelParts.length > 1) {

  }
  return labelParts.length > 1 ? labelParts[0] + bullet.buttonLabels[0] + labelParts[1] : labelParts[0];
};
/*
export const getDivider = (startElem, endElem, divider = '-') => {
  if ((typeof startElem !== 'undefined' && startElem !== '') && (typeof endElem !== 'undefined' && endElem !== '')) {
    return divider;
  }
  return '';
};

export const getStartDate = (item) => {
  const month = item.start_month === undefined ? '' : item.start_month;
  const year = item.start_year === undefined ? '' : item.start_year;
  return month + ' ' + year;
};
export const getEndDate = (item) => {
  const month = item.end_month === undefined ? '' : item.end_month;
  const year = item.end_year === undefined ? '' : item.end_year;
  if (month === '' && year === '') {
    return '- Present';
  }
  return '- ' + month + ' ' + year;
};*/
export const getJobInfo = (props) => {

  const jobInfo = props.stateProps.dataToSave.saved.resumes[props.stateProps.sectionData.resumeIndex]['job-posting'];
  return {
    companyName: jobInfo[0].name,
    address:jobInfo[0].address,
    city:jobInfo[0].city,
    state:jobInfo[0].state,
    zip:jobInfo[0].zip,
  };
}
export const editResults = (uv,props) => {
  if (window.confirm('Are you sure you want to delete your existing results?')) {
    uv.resume['parse-letter'][0]['PL6'] = '';
    onSubmit(uv.formikProps, uv.stateProps, uv.sectionName);
    onLink(false,uv.formikProps, uv.stateProps, 'job-posting');
  }
}
export const getNotes = (isAdmin, props) => {
  const uv = getUsefulVars(props);
  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const questions = props.sections['questions'];
  if (isAdmin) {
    return (
      Object.entries(jobSeekerData).map((secParts, index) => {
          return (
            <Box>
              {progressiveFormStepper(props, questions, index)}
            </Box>
          );
        },
      )
    );
  } else {
    const notes = 'yo';//uv.resume['preview-letter'][0]['notes'];
    return (
      <Box><Heading>Job Counselor Notes</Heading><Box>{notes}</Box></Box>
    );
  }
};
